import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SimpleService } from '../../../../../services/api-appointment/simple/simple.service';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { SimpleAppointmentStatus, SimpleRequestStatus } from '../../../../../models/api-appointment/simple/simple.request.model';
import { TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-appointment-view',
  templateUrl: './appointment-view.component.html',
  styleUrls: ['./appointment-view.component.css']
})
export class AppointmentViewComponent implements OnInit {

  id: number;
  formBuilder: FormGroup;
  goBackUrl: string = "/appointment/appointment";
  request: any = {};
  pendingBtns: boolean = false;
  confirmedBtns: boolean = false;
  email: '';
  telephone: '';
  name: '';
  appointmentStatus: '';
  surname: '';
  isFastwebCustomer: string;
  topicTitle: '';
  storeComsy: '';
  storeAddress: string;
  clientCode: string;
  appointmentDate: '';
  reservationDate: '';
  flgConsentCommMktgLead: any = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private simpleService: SimpleService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,


  ) {
    this.id = this.route.snapshot.params['id'];
    this.initForm();

   }

  ngOnInit(): void {
    this.loadDataByID(this.id);
  }

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }

  loadDataByID(idObj) {
    this.spinner.show();
    this.simpleService.getEntity(idObj).subscribe(
      (response) => {
        if (response) {
          this.setFormValue(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni del\'appuntamento ', 'Caricamento appuntamento', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  initForm() {
    this.formBuilder = this.fb.group({
      name: [""],
      appointmentStatus: [""],
      surname: [""],
      telephone: [""],
      email: [""],
      isFastwebCustomer: [""],
      topicTitle: [""],
      storeComsy: [""],
      storeAddress: [""],
      clientCode: [""],
      appointmentDate: [""],
      reservationDate: [""],
    });
  }

  getFormValue(requestAction) {
    let request = new SimpleRequestStatus();
    request.appointmentStatus = SimpleAppointmentStatus.COMPLETED;
    switch (requestAction) {
      case 'CONFIRMED': request.appointmentStatus = SimpleAppointmentStatus.CONFIRMED; break;
      case 'CANCELLED': request.appointmentStatus = SimpleAppointmentStatus.CANCELLED; break;
      case 'COMPLETED': request.appointmentStatus = SimpleAppointmentStatus.COMPLETED; break;
    }
    return request;
  }

  setFormValue(response) {
    this.appointmentStatus = response.appointmentStatus;
    this.surname = response.surname;
    this.name = response.name;
    this.telephone = response.telephone;
    this.email = response.email;
    if (response.isFastwebCustomer == TRUE) {
      this.formBuilder.controls['isFastwebCustomer'].setValue('Si');
      this.isFastwebCustomer = 'Si';
    } else {
      this.isFastwebCustomer = 'No';
    }
    this.topicTitle = response.topicTitle;
    this.storeComsy = response.storeComsy;
    this.storeAddress = response.city + ',' + ' ' + response.address;
    this.appointmentDate = response.appointmentDate;
    this.reservationDate = response.reservationDate;
    if (response.clientCode == null) {
      this.clientCode = 'Non presente';

    } else {
      this.clientCode = response.clientCode;
    }

    if ( typeof response.flgConsentCommMktgLead != typeof undefined && response.flgConsentCommMktgLead != null) {
      this.flgConsentCommMktgLead = response.flgConsentCommMktgLead;
    }


    this.checkAppointmentStatus(response.appointmentStatus);
  }

    /**
   * Azione click su button Annulla
   */
  clickButtonCancel() {
    //Torna indietro alla tabella
    this.router.navigate([this.goBackUrl]);
  }

  reserveButton(request) {
    this.request = this.getFormValue(request);
    this.simpleService.changeStatus(this.id, this.request).subscribe(
      (response) => {
        if (response) {
          //Salvata modifica
          this.toastr.success('Status modificato con successo', 'Modifica Status', {
            timeOut: 5000
          });
          this.router.navigate([this.goBackUrl]);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante la modifica dello status', 'Modifica Status', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  checkAppointmentStatus(status) {
    if (status == SimpleAppointmentStatus.PENDING) {
      this.pendingBtns = true;

    } else if (status == SimpleAppointmentStatus.CONFIRMED) {
      this.confirmedBtns = true;
    }
  }
}
